import { Log } from '@/logging/datadog';
import Script from 'next/script';
import * as React from 'react';

const ScriptTags = () => {
  const segmentWriteKey = process.env.NEXT_PUBLIC_SEGMENT_WRITE_KEY;

  React.useEffect(() => {
    // Only load Boost chat in production to avoid local/CORS errors
    if (process.env.NODE_ENV !== 'production') return;

    // Check if script already exists
    const existingScript = document.querySelector('script[src*="chatPanel.js"]');

    if (!existingScript) {
      const script = document.createElement('script');
      script.src = 'https://syn.boost.ai/chatPanel/chatPanel.js';
      script.async = true;

      script.onerror = () => {
        // Avoid throwing on network errors (keeps local/dev quiet)
        Log.warning('Boost chat failed to load');
      };

      script.onload = () => {
        // @ts-expect-error window.boostInit comes from the loaded script
        const { chatPanel } = window.boostInit('syn', {});

        chatPanel.addEventListener(
          'triggerAction',
          (ev: { detail: { actionId: string | number; durationBeforeTimeout: number | undefined } }) => {
            setTimeout(() => {
              chatPanel.triggerAction(ev.detail.actionId);
            }, ev.detail.durationBeforeTimeout);
          }
        );
      };
      document.body.appendChild(script);

      return () => {
        // Cleanup on unmount
        document.body.removeChild(script);
      };
    }
    return () => {};
  }, []);

  return (
    <>
      {segmentWriteKey && (
        <Script id="segment-snippet" strategy="afterInteractive">
          {`
            !function(){
              var i="analytics",analytics=window[i]=window[i]||[];
              if(!analytics.initialize)
                if(analytics.invoked) window.console && console.error && console.error("Segment snippet included twice.");
                else {
                  analytics.invoked = true;
                  analytics.methods = [
                    "trackSubmit","trackClick","trackLink","trackForm","pageview",
                    "identify","reset","group","track","ready","alias","debug",
                    "page","once","off","on","addSourceMiddleware",
                    "addIntegrationMiddleware","setAnonymousId","addDestinationMiddleware"
                  ];
                  analytics.factory = function(t){
                    return function(){
                      var e = Array.prototype.slice.call(arguments);
                      e.unshift(t);
                      analytics.push(e);
                      return analytics;
                    };
                  };
                  for(var t = 0; t < analytics.methods.length; t++){
                    var key = analytics.methods[t];
                    analytics[key] = analytics.factory(key);
                  }
                  analytics.load = function(key, t){
                    var e = document.createElement("script");
                    e.type = "text/javascript";
                    e.async = true;
                    e.src = "https://cdn.segment.com/analytics.js/v1/" + key + "/analytics.min.js";
                    var n = document.getElementsByTagName("script")[0];
                    n.parentNode.insertBefore(e, n);
                    analytics._loadOptions = t;
                  };
                  analytics._writeKey = "${segmentWriteKey}";
                  analytics.SNIPPET_VERSION = "4.15.3";
                  analytics.load("${segmentWriteKey}");
                }
            }();
          `}
        </Script>
      )}

      <Script
        id="gtm-script"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
            (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer','GTM-NLZRCT');`,
        }}
      />
      <Script
        id="hotjar-script"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
            (function(h,o,t,j,a,r){
              h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
              h._hjSettings={hjid:771167,hjsv:6};
              a=o.getElementsByTagName('head')[0];
              r=o.createElement('script');r.async=1;
              r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
              a.appendChild(r);
            })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');`,
        }}
      />
    </>
  );
};

export default ScriptTags;
